export default "__VITE_ASSET__46ed09d8__"